import {
  Box,
  Button,
  Container,
  createStyles,
  Menu,
  Modal,
  Text,
} from "@mantine/core";
import { DatePickerInput } from "@mantine/dates";

import moment from "moment";

import { useEffect, useState } from "react";
import { getAllBillingModal } from "../../services";

const useStyles = createStyles(() => ({
  wrapper: {
    // borderRadius: "8px",
    // background: "var(--app-surface-2)",
    background: "var(--app-surface-2)",
    padding: "12px",
    border: "1px solid var(--app-border)",
    display: "flex",
    gap: "7px",
    flexDirection: "column",
    // padding: "13px 19px",
  },

  modal: {
    width: "100%",
    overflow: "auto",
    // borderRadius:'16px !important',
    // borderRadius: "1rem 1rem 1rem 1rem",
    boxShadow: "0 0 10px rgba(0, 0, 0, 0.2)",
    "& .mantine-Paper-root": {
      overflow: "initial !important",
    },
    "& .mantine-Modal-inner": {
      padding: "0px !important",
    },
    // "& .mantine-Modal-header": {
    //   display: "none",
    // },

    "@media (max-width:400px)": {
      width: "auto",
    },
    "& .mantine-1q36a81": {
      padding: "0",
    },
  },
  datepicker: {
    padding: "10px 16px ",
    borderRadius: "8px !important",
    ackground: "var(--app-surface-2) !important",
    border: "1px solid var(--app-border) !important",
     width: "137px",
    minWidth:'max-content',
         boxShadow:
      "0px 1px 2px 0px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px var(--app-surface-2)",
    marginTop: "12px",
    // height: "55px",

 
  },

  btn: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 10,
    background: "var(--app-surface)",
    borderRadius: "8px",
    border: "1px solid var(--app-border)",
    // marginTop: 50,
    flexDirection: "column",
    padding: "12px",
  },

  filterBtn: {
    margin: "1rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "95%",
    gap: "1rem",
  },

  width100: {
    width: "100%",
  },
}));

const ClaimFilter = ({ filtermodal, setFilterModal }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [dateRangeVal, setDateRangeVal] = useState([]);
  const [loading, setLoading] = useState(false);
  const [oneDayValue, setOneDayValue] = useState(null);
  const [dateRange, setDateRange] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);

  const [calendarOpen, setCalendarOpen] = useState(false);

  const handleCalendarOpen = () => {
    setCalendarOpen(true);
  };

  //   let userType = profile?.user?.type;
  //   const navigate = useNavigate();
  const { classes } = useStyles();

  const handleclose = () => {
    setFilterModal(false);
  };

  // console.log("dateRange", dateRange);

  useEffect(() => {
    let payload = {
       page: currentPage,
      dateRange: dateRange?.map((date) => date.toISOString()).join(","),
    };
    getAllBillingModal(payload);

    // handleCancelDateRange();
  }, [dateRange]);

  const handleDateRange = (dates) => {
    setCalendarOpen(false);
    if (dates[0] == null && dates[1] == null) {
      setDateRangeVal([]);
    } else {
      setDateRangeVal(dates);
    }
  };

  const handleDateChange = (date) => {
    setOneDayValue(date);
  };



  const handleSaveDateRange = () => {
    if (dateRangeVal?.length) {
      let startDate = moment(dateRangeVal[0]).startOf("day");
      let endDate = moment(dateRangeVal[1]).endOf("day");
      setDateRange([startDate, endDate]);
    } else if (oneDayValue) {
      let startDate = moment(oneDayValue).startOf("day");
      let endDate = moment(oneDayValue).endOf("day");
      setDateRange([startDate, endDate]);
    }
     handleclose();
   // setDropdownOpen(false);
  };

  // getAllBillingModal

  const handleCancelDateRange =async () => {
    setDateRangeVal([]);
     setOneDayValue(null);
    setDropdownOpen(false);
    await getAllBillingModal({ page: 1 });
     handleclose();
  };

  return (
    <Modal
      opened={filtermodal}
      onClose={handleclose}
      className={classes.modal}
      // className={`${classes.modal} custom-modal`}
      size={500}
      radius={"lg"}
      title="Filter"
      overlayProps={{ blur: 3 }}
      // withCloseButton={false}
      // radius={"lg"}
      
      sx={{
        '.mantine-19pz3dh': {
          borderRadius: '16px !important',
        },
        '.mantine-1fholi4': {
          color: "var(--app-text)",
        },
      }}
      
      zIndex={1000}
      // bg={"var(--app-surface-2)"}
      styles={{
        title: {
          color: "var(--app-text)",
          fontSize: "24px",
          fontWeight: "700",
        },
        // header: {
        //   display: calendarOpen ? "block" : "block",
        // },
      }}
      centered
    >
 
      <Box className={classes.wrapper}>
   
        <Box className={classes.btn}>
          <Box className={classes.width100}>
            <Text ff={"Inter"} fz={"14"} fw={"500"} color={"var(--app-text)"}>
              Select Date Range
            </Text>
            <Box className={classes.datepicker}>
              <DatePickerInput
                onClick={handleCalendarOpen}
                // onChange={handleCalendarChange}
                size="md"
                clearable
    
                // m={".5rem"}
                icon={
                  <img
                    style={{ width: "20px" }}
                    src={"/assets/images/billingcalendar.png"}
                    alt="Icon"
                  />
                }
                sx={{
                  "& .mantine-15cfudd": {
                    border: "none",
                  },
               

                  "& .mantine-1d4lrir": {
                    border: "none !important",
                
                  }
                }}
                
                type="range"
                value={dateRangeVal}
                disabled={oneDayValue}
                // label="Select Date Range"
                onChange={handleDateRange}
                placeholder="Select Date Range"
              />
            </Box>
          </Box>
        </Box>

        <Box style={{ marginBottom: "30px" }} className={classes.btn}>
          <Box className={classes.width100}>
            <Text ff={"Inter"} fz={"14"} fw={"500"} color={"var(--app-text)"}>
              Select Date
            </Text>

            <Box className={classes.datepicker}>
              <DatePickerInput
                // className={classes.datepicker}
                clearable
                size="md"
                top={160}
                icon={
                  <img
                    style={{ width: "20px" }}
                    src={"/assets/images/billingcalendar.png"}
                    alt="Icon"
                  />
                }
                sx={{
                  "& .mantine-15cfudd": {
                    border: "none",
                  },
               

                  "& .mantine-1d4lrir": {
                    border: "none !important",
                
                  }
                }}
                // m={".5rem"}
                // label="Select Date"
                placeholder="Select Date"
                value={oneDayValue}
                onChange={handleDateChange}
                disabled={dateRangeVal?.length}
              />
            </Box>
          </Box>
        </Box>
      </Box>
      <Box className={classes.filterBtn}>
        <Button
          size="sm"
          radius={8}
          
          c="var(--app-text)"
          variant="fixed"
          bg="var(--app-surface-2)"
          style={{boxShadow:'0px 1px 2px 0px rgba(16, 24, 40, 0.05)',border:'1px solid var(--Gray-300, var(--app-border))'}}
          onClick={handleCancelDateRange}
        >
          Reset
        </Button>
        <Button
          size="sm"
          radius={8}
          bg="var(--app-text)"
          c="var(--app-surface)"
          variant="fixed"
          disabled={loading}
          onClick={handleSaveDateRange}
        >
          Apply
        </Button>
      </Box>
    </Modal>
  );
};

export default ClaimFilter;
